import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TChatOnboardingState, TChatOnboardingType } from '../../types/chatOnboarding';

const initialState: TChatOnboardingState = {
  builder: {
    available: false,
    onboardingText: '',
  },
};

export const chatOnboardingSlice = createSlice({
  name: 'chatOnboarding',
  initialState,
  reducers: {
    setChatOnboardingUnavailable: (state, action: PayloadAction<TChatOnboardingType>) => {
      state[action.payload] = {
        available: false,
        onboardingText: '',
      };
    },
  },
});

export const {
  reducer: chatOnboardingReducer,
  actions: { setChatOnboardingUnavailable },
} = chatOnboardingSlice;
